import { UAParser } from "ua-parser-js"

export const checkDesktop = (): boolean => {
  const os = new UAParser().getOS()

  return Boolean(os.name && /(windows|mac\sos|linux)/i.test(os.name))
}
